<template>
  <v-layout>
    <v-btn
      @click="onChangePage('prev', $event)"
      color="primary"
      small
      :disabled="!hasPrev || value == 1"
      depressed
      fab
      class="my-0"
      :loading="loading"
      ><v-icon>arrow_back_ios</v-icon></v-btn
    >
    <div class="form-control">
      <input
        type="text"
        :value="value"
        :disabled="loading"
        v-on:keyup.enter="onChangePage('blur', $event)"
        @blur="onChangePage('blur', $event)"
        style="width: 50px; text-align: center; padding: 5px;"
      />
      / {{ pagelength }}
    </div>
    <v-btn
      @click="onChangePage('next', $event)"
      color="primary"
      small
      :disabled="!hasNext || value == pagelength"
      depressed
      fab
      class="my-0"
      :loading="loading"
      ><v-icon>arrow_forward_ios</v-icon></v-btn
    >
  </v-layout>
</template>

<script>
export default {
  props: {
    value: {
      default: 1
    },
    hasNext: {
      default: false
    },
    pagelength: { default: 1 },
    hasPrev: {
      default: false
    },
    loading: {
      default: false
    }
  },
  data() {
    return {}
  },
  methods: {
    onChangePage(type, event) {
      var page = this.value
      var newpage = this.value
      var isPass = true
      switch (type) {
        case 'prev':
          newpage = newpage - 1
          break
        case 'blur':
          try {
            newpage = parseInt(event.target.value)
          } catch (error) {
            isPass = false
            event.target.value = page
          }
          break
        case 'next':
          newpage = newpage + 1
          break

        default:
          break
      }
      if (!isPass) return false

      var vm = this
      this.$emit('onChangePage', {
        currentpage: page,
        newpage: newpage,
        onchange: function(newpage) {
          vm.$emit('input', newpage)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/CustomPaginate.vue